<template>
  <loading-overlay v-if="loading" class="animated fadeIn" />
  <div v-else class="animated fadeIn mb-4">
    <default-heading class="mt-3">
      Sample Detail

      <template #right>
        <SampleCoordsManager
          v-if="sample"
          :sample="sample"
          @coords-updated="handleGpsUpdated"
        />
      </template>
    </default-heading>

    <div class="mt-3" />

    <b-row>
      <b-col>
        <b-card>
          <div>
            <h4>{{ sample ? sample.pid : 'TBD' }}</h4>

            <b-table-lite
              :items="sampleInfoRows"
              striped
              small
              bordered
              thead-class="d-none"
            />
          </div>
        </b-card>
      </b-col>

      <b-col>
        <b-card>
          <h4>Sample Status</h4>

          <b-table-lite
            :items="sampleStatusInfoRows"
            striped
            small
            bordered
            thead-class="d-none"
          />
        </b-card>
      </b-col>
    </b-row>

    <b-row v-if="sample && sample.lat && sample.long" class="mb-1">
      <b-col>
        <b-card no-body>
          <MapboxMap :initial-coordinates="sample_coordinates" :interactive="false" />
        </b-card>
      </b-col>
    </b-row>

    <SampleDetailCardstack :sample="sample" />
  </div>
</template>

<script>
import DefaultHeading from '@/components/shared/DefaultHeading'
import LoadingOverlay from '@/components/shared/LoadingOverlay'
import SampleModel from '@/models/lab/SampleModel'
import moment from 'moment'
import SampleDetailCardstack from '@/components/lab/samples/SampleDetailCardstack.vue'
import MapboxMap from '@/components/shared/MapboxMap.vue'
import ToastNotifications from '@/components/shared/mixins/ToastNotifications'
import SampleCoordsManager from '@/components/lab/samples/SampleCoordsManager.vue'

export default {
  name: 'SampleDetail',
  components: {
    DefaultHeading,
    LoadingOverlay,
    SampleDetailCardstack,
    MapboxMap,
    SampleCoordsManager
  },
  mixins: [ToastNotifications],
  data () {
    return {
      sample_id: this.$route.params.id || null,
      loading: true,
      sample: null,
      sample_coordinates: null
    }
  },
  computed: {
    sampleInfoRows () {
      const rows = []

      if (this.sample) {
        rows.push(
          {
            label: 'Project',
            value: this.sample.submission.project.pid || 'Not Specified'
          },
          {
            label: 'Submission',
            value: this.sample.submission.pid || 'Not Specified'
          },
          {
            label: 'Sample Type',
            value: this.sample.sample_type.name || 'Not Specified'
          },
          {
            label: 'Grower',
            value: this.sample.submission.submission_soil && this.sample.submission.submission_soil.grower || 'Not Specified'
          },
          {
            label: 'Field',
            value: this.sample.submission.identifier || 'Not Specified'
          }
        )
      }

      return rows.filter(row => row.value && row.value !== 'Not Specified')
    },

    sampleStatusInfoRows () {
      const rows = []

      if (this.sample) {
        rows.push(
          {
            label: 'Status',
            value: this.sample.current_sample_status_log.sample_status.status || 'Not Specified'
          },
          {
            label: 'Received At',
            value: (this.sample.received_at && moment(this.sample.received_at).format('MMMM Do YYYY')) || 'Not Specified'
          },
          {
            label: 'Prepped At',
            value: (this.sample.prepped_at && moment(this.sample.prepped_at).format('MMMM Do YYYY')) || '--'
          },
          {
            label: 'Tested At',
            value: (this.sample.tested_at && moment(this.sample.tested_at).format('MMMM Do YYYY')) || '--'
          },
          {
            label: 'Completed At',
            value: (this.sample.completed_at && moment(this.sample.completed_at).format('MMMM Do YYYY')) || '--'
          }
        )
      }

      return rows.filter(row => row.value && row.value !== 'Not Specified')
    },
  },
  mounted () {
    this.fetchSample()
  },
  methods: {
    async fetchSample () {
      const model = new SampleModel({ id: this.sample_id })
      model.fetch().then(() => {
        this.sample = model
        if (this.sample.lat && this.sample.long) {
          this.sample_coordinates = {
            lat: parseFloat(this.sample.lat),
            lng: parseFloat(this.sample.long)
          }
        } else {
          this.sample_coordinates = null
        }
        this.loading = false
      })
    },

    handleGpsUpdated(updatedCoords) {
      if (this.sample && this.sample.id === updatedCoords.id) {
        // Update the local sample model's properties
        this.sample.set('lat', updatedCoords.lat);
        this.sample.set('long', updatedCoords.long);
        this.sample.set('customer_coord_id', updatedCoords.customer_coord_id);

        // Update coordinates for the map display in this component
        if (updatedCoords.lat && updatedCoords.long) {
          this.sample_coordinates = {
            lat: parseFloat(updatedCoords.lat),
            lng: parseFloat(updatedCoords.long)
          };
        } else {
          this.sample_coordinates = null;
        }
      }
    }
  }
}
</script>
